import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { ConfigInitializer, SiteContextConfig } from '@spartacus/core';
import { Observable, firstValueFrom } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StoreContextConfigInitializer implements ConfigInitializer {
  readonly scopes = ['context.baseStore'];

  constructor(private baseStoreFacade: BaseStoreFacade) {}

  readonly configFactory = (): Promise<SiteContextConfig> => firstValueFrom(this.resolveConfig());

  /**
   * Получает список бейссторов с бекенда и инжектит значения в конфиг
   */
  protected resolveConfig(): Observable<SiteContextConfig> {
    return this.baseStoreFacade.getBaseStores().pipe(
      map((baseStores) => ({
        context: {
          baseStore: baseStores.map((bs) => bs.code),
        },
      })),
      take(1),
    );
  }
}

/**
 * Динамическая инициализация конфига context.baseStore
 */
export function initStoreContextConfig(
  configInitializer: StoreContextConfigInitializer,
  config: SiteContextConfig,
): ConfigInitializer | null {
  /**
   * Загружает конфиг `context.baseStore` с бекенда, только если не найден статический конфиг
   */
  if (!config.context || !config.context.baseStore) {
    return configInitializer;
  }

  return null;
}
